import { ConfigStyled } from "./configStyle";
import { PotholeFilterStatus } from "./container";

const App = () => {
  return (
    <ConfigStyled>
      <div className="App">
        <PotholeFilterStatus />
      </div>
    </ConfigStyled>
  );
};

export default App;
